<div class="distribuzione-container">
  <div class="distribuzione-chart-wrapper" *ngIf="distribuzione && risultati.length > 1; else senzaGrafico">
    <ngx-charts-bar-vertical
      [scheme]="colorScheme"
      [customColors]="coloriBarre"
      [results]="risultati"
      [xAxis]="true"
      [yAxis]="true"
      [showXAxisLabel]="false"
      [showYAxisLabel]="false"
      [roundEdges]="false"
    ></ngx-charts-bar-vertical>
  </div>
  <div class="distribuzione-legenda" *ngIf="distribuzione && risultati.length > 1 && legenda.length">
    <span class="voce-legenda" *ngFor="let voce of legenda">
      <span class="swatch" [style.background-color]="voce.colore"></span>{{ voce.etichetta }}
    </span>
  </div>

  <ng-template #senzaGrafico>
    <p class="distribuzione-vuota" *ngIf="!distribuzione">Nessun valore numerico disponibile per la distribuzione.</p>
    <p class="distribuzione-vuota" *ngIf="distribuzione && risultati.length === 1">
      Tutti i valori disponibili sono pari a {{ formatta(distribuzione.min) }} {{ unitaMisura }}.
    </p>
  </ng-template>
</div>
